export default [
  {
    path: '/pages/admin/businessOpportunity',
    name: '/pages/admin/businessOpportunity',
    component: () => import('@/views/businessOpportunity/businessOpportunityList.vue')
  },
]